import AxiosConfig from '@/config/axios-config'

export const NpsAPI = {

  async checkIfUserCanAnswerNpsAndCreate (baseUrlInitializedNps) {
    let response = await AxiosConfig.npsAPI().get('nps', {
      params: {
        url_base_fonte_de_cadastro_nps: baseUrlInitializedNps
      }
    })
    return response.data
  },

  async answerNps (nps) {
    let response = await AxiosConfig.npsAPI().post('nps', nps)
    return response.data
  }

}

export default NpsAPI
